<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">

        

        <sidebar-link v-if="!auth" to="/login" name="Inicio de Sesion" icon="ti-lock" />

        <li class="nav-item" v-if="!auth">
            <a href="#" class="nav-link" @click="irPaginaWeb">
              <b> <i class="ti-world text-dark"></i> </b>
              <p > <b class="text-dark"> Ir a la Pagina Web </b></p>
            </a>
        </li>


        <!-- <sidebar-link to="/dashboard" name="Dashboard" icon="ti-panel" /> -->
        <sidebar-link v-if="auth" to="/stats" name="Perfil de Usuario" icon="ti-user" />
<!--         <sidebar-link v-if="auth" to="/enlaces" name="Enlaces" icon="ti-panel" />
 -->

        


        <sidebar-link v-if="auth" to="/numeros" name="NÚMEROS DE INTERNOS" icon="ti-headphone-alt" />



<!--         <sidebar-link to="/typography" name="Typography" icon="ti-text" />
        <sidebar-link to="/icons" name="Icons" icon="ti-pencil-alt2" />  -->


        <!-- <sidebar-link v-if="auth" to="/chat" name="Chat" icon="ti-comments" /> -->

        <!-- <sidebar-link v-if="auth" to="/system" name="SISDC" icon="ti-desktop" />  -->


<!--          <sidebar-link v-if="auth" v-for="(sis, key) in sistemasper"  :key="key" :to="{ path: '/system', query: { id: sis.sistema.id, Nombre: sis.sistema.Nombre, URL: sis.sistema.URL } }" :name="sis.sistema.Descripcion" icon="ti-desktop"/>
 -->

           <!--  <sidebar-link v-if="auth && isAdmin"
              v-for="(sis, key) in sistemasper"
              :key="key"
              :to="{ path: '/system', query: { id: sis.sistema.id, Nombre: sis.sistema.Descripcion, URL: sis.sistema.URL } }"
              :name="sis.sistema.Descripcion"
              icon="ti-desktop"
              :class="{ 'router-link-active': $route.query.id === sis.sistema.id }"
            />

            <sidebar-link v-if="auth && isDocente"
              v-for="(sis, key) in sistemasperDoc"
              :key="key"
              :to="{ path: '/system', query: { id: sis.id, Nombre: sis.Descripcion, URL: sis.URL } }"
              :name="sis.Descripcion"
              icon="ti-desktop"
              :class="{ 'router-link-active': $route.query.id === sis.id }"
            />

            <sidebar-link v-if="auth && isEstudiante"
              v-for="(sis, key) in sistemasperEst"
              :key="key"
              :to="{ path: '/system', query: { id: sis.id, Nombre: sis.Descripcion, URL: sis.URL } }"
              :name="sis.Descripcion"
              icon="ti-desktop"
              :class="{ 'router-link-active': $route.query.id === sis.id }"
            /> -->

         <li class="nav-item" v-if="auth">
            <a href="#" class="nav-link" @click="cerrarSesion">
              <b> <i class="ti-shift-left text-dark"></i> </b>
              <p > <b class="text-dark"> Cerrar Sesion </b></p>
            </a>
          </li>

        



        <!-- <sidebar-link
          to="/table-list"
          name="Table List"
          icon="ti-view-list-alt"
        /> 
        <sidebar-link to="/typography" name="Typography" icon="ti-text" />
        <sidebar-link to="/icons" name="Icons" icon="ti-pencil-alt2" />
        <sidebar-link to="/maps" name="Map" icon="ti-map" />
        <sidebar-link to="/notifications" name="Notifications" icon="ti-bell" /> -->
      </template>
      <mobile-menu>
        <!-- <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li> -->
        <!-- <drop-down
          class="nav-item"
          title="5 Notifications"
          title-classes="nav-link"
          icon="ti-bell"
        >
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down> -->
        <!-- <li class="nav-item" v-if="auth">
          <a class="nav-link bg-dark" @click="cerrarSesion" >
            <i class="ti-shift-right text-primary"></i>

            <p>Cerrar Sesion</p>
          </a>
        </li> -->
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
    <!-- <div class=""> -->
      <div class="topBar">
        <top-navbar></top-navbar>
      </div>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

.topBar {
  display: none;
}

/* Cuando el ancho de la pantalla sea menor a 500px, mostramos la etiqueta */
@media (max-width: 995px) {
  .topBar {
    display: block;
  }
}
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import MainService from "@/services/MainService.js";

import { EventBus } from '@/plugins/event-bus';  // Importa el bus de eventos

export default {

  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },

  data() {
    return {
      ss: new MainService(),
      auth:{},
      isAdmin: false,
      isEstudiante: false,
      isDocente: false,
      sistemasper:[],
      sistemasperEst:[
        {
          id: 4,
          Nombre:'BIBLIOTECA',
          URL:'https://biblioteca.emi.edu.bo/#/login',
          Descripcion:'SISBLI'
        },
        {
          id: 41,
          Nombre:'SISTEMA DE CURSOS CORTOS',
          URL:'https://cursos.dev.emi.edu.bo/login',
          Descripcion:'SISCUR'
        },
        {
          id: 18,
          Nombre:'SISTEMA REPOSITORIO GRADO',
          URL:'HTTPS://REPOSITORIOGRADO.EMI.EDU.BO/#/LOGIN',
          Descripcion:'SISREG'
        },
        {
          id: 19,
          Nombre:'SISTEMA REPOSITORIO POSGRADO',
          URL:'https://repositorioposgrado.emi.edu.bo/#/Login',
          Descripcion:'SISREP'
        },
        {
          id: 16,
          Nombre:'SISTEMA GABINETE PSICOLÓGICO',
          URL:'https://gabinetepsicologico.emi.edu.bo/login',
          Descripcion:'SISGAP'
        },
        {
          id: 9,
          Nombre:'SISTEMA GESTION DE TRABAJOS DE GRADO',
          URL:'https://sistg.emi.edu.bo/#/Login',
          Descripcion:'SISTG'
        },
        {
          id: 37,
          Nombre:'SISTEMAS DE NOTAS',
          URL:'HTTPS://NOTAS.EMI.EDU.BO/LOGIN',
          Descripcion:'SISNOTAS'
        },
      ],
      sistemasperDoc:[
        {
          id: 4,
          Nombre:'BIBLIOTECA',
          URL:'https://biblioteca.emi.edu.bo/#/login',
          Descripcion:'SISBLI'
        },
        {
          id: 41,
          Nombre:'SISTEMA DE CURSOS CORTOS',
          URL:'https://cursos.dev.emi.edu.bo/login',
          Descripcion:'SISCUR'
        },
        {
          id: 35,
          Nombre:'SISTEMA DE CERTIFICACION DE INGLES',
          URL:'https://ingles.emi.edu.bo/#/login',
          Descripcion:'SISING'
        },
        {
          id: 6,
          Nombre:'SISTEMA DE DEFENSAS DE GRADO',
          URL:'https://defensasgrado.emi.edu.bo/login',
          Descripcion:'SISDEG'
        },
        {
          id: 7,
          Nombre:'SISTEMA DE DEFENSAS POSGRADO',
          URL:'HTTPS://DEFENSASPOSGRADO.EMI.EDU.BO/#/LOGIN',
          Descripcion:'SISDEP'
        },
        {
          id: 18,
          Nombre:'SISTEMA REPOSITORIO GRADO',
          URL:'HTTPS://REPOSITORIOGRADO.EMI.EDU.BO/#/LOGIN',
          Descripcion:'SISREG'
        },
        {
          id: 19,
          Nombre:'SISTEMA REPOSITORIO POSGRADO',
          URL:'https://repositorioposgrado.emi.edu.bo/#/Login',
          Descripcion:'SISREP'
        },
        {
          id: 20,
          Nombre:'SISTEMA DE INFORMACION PARA LA PLANEACION Y EVALUACION ACADEMICA',
          URL:'https://sipdea.emi.edu.bo/#/Login',
          Descripcion:'SIPDEA'
        },
        {
          id: 9,
          Nombre:'SISTEMA GESTION DE TRABAJOS DE GRADO',
          URL:'https://sistg.emi.edu.bo/#/Login',
          Descripcion:'SISTG'
        },
        {
          id: 39,
          Nombre:'SISTEMA DE REGISTRO DE NOTAS DE GRADO',
          URL:'HTTPS://REGISTRO.GRADO.EMI.EDU.BO',
          Descripcion:'SISNG'
        },
        {
          id: 40,
          Nombre:'SISTEMA DE REGISTRO DE NOTAS DE POSGRADO',
          URL:'HTTPS://REGISTRO.POSGRADO.EMI.EDU.BO',
          Descripcion:'SISRPOS'
        },
      ],

      // Variable para almacenar las pestañas abiertas
      openedTabs: [],
    }
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },

  created() {
    // Escuchar el evento de apertura de pestañas
    EventBus.$on('newTabOpened', (tab) => {
      this.openedTabs.push(tab);
    });
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

     /*cerrarSesion() {
      console.log("cerrarrr");
        localStorage.clear();
        this.auth={};
        this.$router.push("/Login");
        location.reload();
        if (this.$msal.isAuthenticated()) {
            this.$msal.signOut();
        }
        // Cuando el usuario cierra sesión
        localStorage.setItem('sessionClosed', 'true');
    },*/

    irPaginaWeb(){
      const url = "https://emi.edu.bo/"; 
      window.open(url, "_blank");
    },

    setClearLocalStorageCookie() {
    // Establecemos una cookie para indicar que el localStorage debe ser limpiado
    document.cookie = "clearLocalStorageDefPosgrado=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageRepoGrado=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageRepoPosgrado=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageBiblioteca=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageSistg=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageIngles=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageSipdea=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageDiseno=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración
    document.cookie = "clearLocalStorageConvenios=true; path=/; domain=.emi.edu.bo; max-age=3600"; // 1 hora de duración

    //document.cookie = "clearLocalStorage=true; path=/; domain=localhost; max-age=3600"; // 1 hora de duración
    const email = this.auth.email;

    document.cookie = "userEmail="+email+"; path=/; domain=.emi.edu.bo; max-age=3600";
    //document.cookie = "userEmail="+email+"; path=/; domain=localhost; max-age=3600";
    
    },

    // Borrar cookies asociadas al dominio .emi.edu.bo
    borrarCookies() {
        let cookies = document.cookie.split(";");

        console.table(cookies);
    
        cookies.forEach((cookie) => {
            const cookieName = cookie.split("=")[0].trim();
            // Borramos la cookie configurando una fecha de expiración en el pasado
            document.cookie = cookieName+"=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.emi.edu.bo";
        });
        
    },

    cerrarSesion() {

      // Cerrar todas las pestañas abiertas
      this.openedTabs.forEach(tab => {
        if (tab) {
          tab.close();
        }
      });

      // Vaciar la lista de pestañas abiertas después de cerrarlas
      this.openedTabs = [];
      
      // Borrar cookies asociadas al dominio .emi.edu.bo
      this.borrarCookies();
      this.setClearLocalStorageCookie(); // Establece la cookie para limpiar el localStorage en los sistemas hijos
      console.log("top");
      localStorage.clear();
      this.auth={};
      // console.log("this.auth",this.auth);
      this.$router.push('/Login');
      location.reload();

      

        // if (!this.auth) {
        //     // this.$router.push('/Login');
        //   console.log("this.auth if",this.auth);

        // }
        // this.$router.push("/login");
        if (this.$msal.isAuthenticated()) {
            this.$msal.signOut();
        }

        localStorage.setItem('sessionClosed', 'true');
    },

    getSistemasPersona() {
      //console.log(this.auth);

        this.ss.listSistemasPersona(this.auth.id).then(
            (result) => {
                let response = result.data;
                this.sistemasper = response.data;
                console.log(this.sistemasper);
            }
        ).catch(error => {
            console.log(error);
            this.isLoading=false;
        });
    },

  },

  mounted() {
    this.auth = JSON.parse(localStorage.getItem('usuario'));

    if(this.auth){
      const email = this.auth.email; // Asumimos que "auth" contiene la información del usuario
  
          // Comprobamos el dominio y actualizamos las variables
          if (email.includes('@adm.emi.edu.bo')) {
              this.isAdmin = true;
              this.isEstudiante = false;
              this.isDocente = false;
          } else if (email.includes('@est.emi.edu.bo')) {
              this.isAdmin = false;
              this.isEstudiante = true;
              this.isDocente = false;
          } else if (email.includes('@doc.emi.edu.bo')) {
              this.isAdmin = false;
              this.isEstudiante = false;
              this.isDocente = true;
          } else {
              // Si no se encuentra en ninguna de las categorías anteriores
              this.isAdmin = false;
              this.isEstudiante = false;
              this.isDocente = false;
          }
  
  
      this.getSistemasPersona();
      // console.log("auth cerrar sesion",this.auth);
      // this.$watch("$route", this.findActiveLink, {
      //   immediate: true,
      // });
    }else{
      this.$router.push('/Login');
    }
  },
};
</script>
